export {
  default 
} from "./relatedProducts";
